import './Participants.scss'

import {Progressbar} from '../ui/Progressbar'
import React from 'react'
import {Theme} from '../Theme'
import {number_format} from '../../util/price'
import {style} from '../../util/style'
import {useTranslation} from '../../util/i18n'

const styles = style('participants', ['item'])

export type ParticipantsType = Array<ParticipantsItemType>

type ParticipantsItemType = {
	title?: string
	url?: string
	team_value: number
	team_total: number
}

export const Participants: React.FC<{
	teamsOverviewLink: string
	participants: ParticipantsType
	numberOfTeams: number
	totalAmount: number
}> = ({participants, numberOfTeams, teamsOverviewLink, totalAmount}) => {
	if (!participants || participants.length === 0) return null
	const t = useTranslation('events').participants
	const totalCopy =
		numberOfTeams === 1
			? t.totalSingle
			: t.total.replace('{{numberOfTeams}}', `${numberOfTeams}`)

	return (
		<div className={styles()}>
			<p className={styles('total')}>
				{totalCopy} <b>€ {number_format(totalAmount, 2, ',', '.')}!</b>
			</p>
			<Theme.H5 className={styles('title')} mod="grey">
				{t.title}
			</Theme.H5>
			{participants.map((item) => (
				<ParticipantsItem key={item.url} {...item} />
			))}
			<div className={styles('link')}>
				<Theme.Link to={teamsOverviewLink}>{t.all}</Theme.Link>
			</div>
		</div>
	)
}

const ParticipantsItem: React.FC<ParticipantsItemType> = ({
	title,
	url,
	team_value: value,
	team_total: total
}) => {
	if (!value && !total) return null
	const t = useTranslation('events').participants

	return (
		<div className={styles.item()}>
			{(title || url) && (
				<div className={styles.item('top')}>
					{title && (
						<Theme.H5 className={styles.item('top-title')}>{title}</Theme.H5>
					)}
					<Theme.Link
						to={url}
						iconafter="chevronRight"
						className={styles.item('top-link')}
					>
						{t.linklabel}
					</Theme.Link>
				</div>
			)}
			<Progressbar value={value} total={total} />
		</div>
	)
}
